import XHeader from './Header'
export default XHeader